import axios from "axios";
import { baseUrl } from "../constants";
//import { setBearerAuthorizationHeader } from "../../utils/interceptors";

const GetDownloads = () => {
    return axios
        .get(`${baseUrl()}/Download/GetDownloads`)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .get(`${baseUrl()}/Download/GetDownloads`)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DownloadServices: Get Downloads API", error);
                    });
            } else {
                console.error("DownloadServices: Get Downloads API", error);
            }
        });
};

const AddDownload = (download) => {
    return axios
        .post(`${baseUrl()}/Download/AddDownload`, {
            startdate: download.startdate,
            enddate: download.enddate,
            freqtype: download.freqtype,
            vesselid: download.vesselid,
            deviceid: download.deviceid
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Download/AddDownload`, {
                        startdate: download.startdate,
                        enddate: download.enddate,
                        freqtype: download.freqtype,
                        vesselid: download.vesselid,
                        deviceid: download.deviceid
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DownloadServices: Add Download API", error);
                    });
            } else {
                console.error("DownloadServices: Add Download API", error);
            }
        });
};

const DeleteDownload = (downloadid) => {
    return axios
        .post(`${baseUrl()}/Download/DeleteDownload/${downloadid}`)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Download/DeleteDownload/${downloadid}`)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DownloadServices: Delete Download API", error);
                    });
            } else {
                console.error("DownloadServices: Delete Download API", error);
            }
        });
};



const DownloadServices = { GetDownloads, AddDownload, DeleteDownload };

export default DownloadServices;
